module.exports = __webpack_public_path__ + "img/profile-man-1-min.8b268f1a.jpg";